import { useEffect, useState } from 'react';

export type LocationSuggestion = {
  cityId: string;
  name: string;
  meta: string;
};

type UseSearchLocationArgs = {
  initialLocation?: string | null;
  initialCityId?: string | null;
  onChange?: () => void;
};

export const useSearchLocation = ({
  initialLocation,
  initialCityId,
  onChange,
  // oxlint-disable-next-line typescript/explicit-function-return-type
}: UseSearchLocationArgs) => {
  const locationValue = initialLocation ?? '';
  const cityIdValue = initialCityId ?? '';

  const [location, setLocation] = useState(locationValue);
  const [cityId, setCityId] = useState(cityIdValue);

  // Check if the URL params have been changed (i.e. by resetting the filters or navigating back with the browser)
  useEffect(() => {
    if (locationValue !== location) {
      setLocation(locationValue);
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, [locationValue]);

  useEffect(() => {
    if (cityIdValue !== cityId) {
      setCityId(cityIdValue);
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, [cityIdValue]);

  const handleOnChangeLocation = (name: string): void => {
    onChange?.();
    setLocation(name);
    setCityId('');
  };

  const handleOnSelectLocation = ({
    name,
    cityId,
  }: LocationSuggestion): void => {
    onChange?.();
    setLocation(name);
    setCityId(cityId);
  };

  return {
    location,
    cityId,
    onChangeLocation: handleOnChangeLocation,
    onSelectLocation: handleOnSelectLocation,
  };
};
